import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, Validators} from '@angular/forms';
import {WizardValidators} from '../../wizard-validators';

@Injectable()
export class OrganizationBankService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        /**
         * БИК банка
         */
        RCBIC: ['', [
            WizardValidators.required('БИК банка'),
            WizardValidators.requiredLength(9, 'БИК банка'),
        ]],

        /**
         * Наименование банка
         */
        bank_name: ['', [
            WizardValidators.required(),
        ]], // Имя банка

        /**
         * Корреспондентский счет
         */
        correspondent_account: ['', [
            WizardValidators.required('Корреспондентский счет'),
            WizardValidators.requiredLength(20, 'Корреспондентский счет'),
        ]],

        /**
         * Расчетный счет
         */
        operating_account: ['', [
            WizardValidators.required('Расчетный счет'),
            WizardValidators.requiredLength(20, 'Расчетный счет'),
        ]]
    });

    constructor(
        private fb: FormBuilder,
    ) {
        super();
    }
}
